import { Exclude, Expose } from 'class-transformer';

export enum PlanType {
  FREE = 'free',
  SHOPLINK = 'shop',
  STARTER = 'starter',
  CUSTOM = 'custom'
}

export enum BillingCycle {
  MONTH = 'month',
  YEAR = 'year'
}

export enum FreePlanName {
  OLD = 'free',
  NEW = 'PERSONAL'
}

@Exclude()
export class PlanDTO {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  billingCycle: BillingCycle;

  @Expose()
  price: number;

  @Expose()
  postLimit: number;

  @Expose()
  memberLimit: number;

  @Expose()
  accountLimit: number;

  @Expose()
  commentLimit: number;

  @Expose()
  period: number;

  @Expose()
  metricsDays: number;

  @Expose()
  analyticsDays: number;

  @Expose()
  type: PlanType;

  @Expose()
  storyLimit: number;

  @Expose()
  uploadsRemain: number;

  @Expose()
  storyUploadsRemain: number;

  @Expose()
  pinterestUploadsRemain: number;

  @Expose()
  setLimit: number;

  @Expose()
  generation: number;

  isFree(): boolean {
    return this.type === PlanType.FREE;
  }

  isAnnual(): boolean {
    return this.billingCycle === BillingCycle.YEAR;
  }

  isCustom() {
    return this.type === PlanType.CUSTOM;
  }

  isNewPlan() {
    return this.setLimit > 0 || this.name === FreePlanName.NEW;
  }

  isPersonalPlan() {
    return this.name === FreePlanName.NEW;
  }

  shouldCheckLimit() {
    return this.postLimit > 0 || this.storyLimit > 0;
  }
}
